import { SliderOrientation, TimeSlider, TooltipPlacement, useMediaState, VolumeSlider } from '@vidstack/react';
import { useDefaultLayoutWord } from "@vidstack/react/player/layouts/default";
import { useActive } from "@/hooks/useActive";
import { useState } from "react";
import { Mute } from "@/components/player/layouts/shared/buttons";
export interface DefaultVolumePopupProps {
  tooltip: TooltipPlacement;
  orientation: SliderOrientation;
}
function VolumePopup({
  tooltip,
  orientation
}: DefaultVolumePopupProps) {
  const $pointer = useMediaState('pointer'),
    $muted = useMediaState('muted'),
    $canSetVolume = useMediaState('canSetVolume'),
    [rootEl, setRootEl] = useState<HTMLElement | null>(null),
    isRootActive = useActive(rootEl),
    muteButton = <Mute tooltipPlacement={tooltip} />;
  if (!$canSetVolume) {
    return muteButton;
  }
  return $pointer === 'coarse' && !$muted ? null : <div className="vds-volume" data-active={isRootActive ? '' : null} ref={setRootEl} data-sentry-component="VolumePopup" data-sentry-source-file="sliders.tsx">
      {muteButton}
      <div className="vds-volume-popup">
        <DefaultVolumeSlider orientation={orientation} data-sentry-element="DefaultVolumeSlider" data-sentry-source-file="sliders.tsx" />
      </div>
    </div>;
}
VolumePopup.displayName = 'VolumePopup';
export { VolumePopup };

/* -------------------------------------------------------------------------------------------------
 * DefaultVolumeSlider
 * -----------------------------------------------------------------------------------------------*/

function DefaultVolumeSlider(props: VolumeSlider.RootProps) {
  const label = useDefaultLayoutWord('Volume');
  return <VolumeSlider.Root className="vds-volume-slider vds-slider" aria-label={label} {...props} data-sentry-element="unknown" data-sentry-component="DefaultVolumeSlider" data-sentry-source-file="sliders.tsx">
      <VolumeSlider.Track className="vds-slider-track" data-sentry-element="unknown" data-sentry-source-file="sliders.tsx" />
      <VolumeSlider.TrackFill className="vds-slider-track-fill vds-slider-track" data-sentry-element="unknown" data-sentry-source-file="sliders.tsx" />
      <VolumeSlider.Thumb className="vds-slider-thumb" data-sentry-element="unknown" data-sentry-source-file="sliders.tsx" />
      <VolumeSlider.Preview className="vds-slider-preview" noClamp data-sentry-element="unknown" data-sentry-source-file="sliders.tsx">
        <VolumeSlider.Value className="vds-slider-value" data-sentry-element="unknown" data-sentry-source-file="sliders.tsx" />
      </VolumeSlider.Preview>
    </VolumeSlider.Root>;
}
DefaultVolumeSlider.displayName = 'DefaultVolumeSlider';
export { DefaultVolumeSlider };
export interface TimeSliderProps {
  thumbnails?: string;
}
export function Time({
  thumbnails
}: TimeSliderProps) {
  return <TimeSlider.Root className="vds-time-slider vds-slider" data-sentry-element="unknown" data-sentry-component="Time" data-sentry-source-file="sliders.tsx">
      <TimeSlider.Chapters className="vds-slider-chapters" data-sentry-element="unknown" data-sentry-source-file="sliders.tsx">
        {(cues, forwardRef) => cues.map(cue => <div className="vds-slider-chapter" key={cue.startTime} ref={forwardRef}>
              <TimeSlider.Track className="vds-slider-track" />
              <TimeSlider.TrackFill className="vds-slider-track-fill vds-slider-track" />
              <TimeSlider.Progress className="vds-slider-progress vds-slider-track" />
            </div>)}
      </TimeSlider.Chapters>

      <TimeSlider.Thumb className="vds-slider-thumb" data-sentry-element="unknown" data-sentry-source-file="sliders.tsx" />

      <TimeSlider.Preview className="vds-slider-preview" data-sentry-element="unknown" data-sentry-source-file="sliders.tsx">
        {thumbnails ? <TimeSlider.Thumbnail.Root src={thumbnails} className="vds-slider-thumbnail vds-thumbnail">
            <TimeSlider.Thumbnail.Img />
          </TimeSlider.Thumbnail.Root> : null}

        <TimeSlider.ChapterTitle className="vds-slider-chapter-title" data-sentry-element="unknown" data-sentry-source-file="sliders.tsx" />

        <TimeSlider.Value className="vds-slider-value" data-sentry-element="unknown" data-sentry-source-file="sliders.tsx" />
      </TimeSlider.Preview>
    </TimeSlider.Root>;
}